import { render, staticRenderFns } from "./ed-list-staff.component.vue?vue&type=template&id=45425338&scoped=true&"
import script from "./ed-list-staff.component.ts?vue&type=script&lang=ts&"
export * from "./ed-list-staff.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-list-staff.component.scss?vue&type=style&index=0&id=45425338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45425338",
  null
  
)

export default component.exports